import { Card, CenteredSpinner, Flex, Icon, Text, Title } from '@wyz/ui';
import { Link } from 'react-router';
import { Trans } from '~/common/context';
import { ROLES } from '~/common/helpers';
import { useAccessControl } from '~/common/hooks';
import { useManageRedistributionGenericRule } from '~/connect/api';

const PinnedGenericRule = () => {
  const acl = useAccessControl();
  const canView = acl.isGranted([ROLES.ROLE_REDISTRIBUTION_GENERIC_RULE_GET]);
  const manageRedistributionGenericRule = useManageRedistributionGenericRule({
    get: { enabled: canView },
  });

  const genericRule = manageRedistributionGenericRule.get.data?.data;

  // The pinned block must never break the list: no role, or a rule the API cannot serve, and it
  // simply stays out of the page.
  if (!canView || manageRedistributionGenericRule.get.isError) {
    return null;
  }

  return (
    <>
      <Title heading='lg' weight='bold' className='mb-2'>
        <Trans i18nKey='app.redistribution_generic_rule.title' />
      </Title>
      <Card className='mb-section'>
        <Card.Body>
          {!genericRule ? (
            <CenteredSpinner />
          ) : (
            <Flex alignItems='center' className='space-x-4'>
              <Link
                id='view-redistribution-generic-rule'
                to='generic-rule'
                aria-label='generic-rule'
              >
                <Icon icon='eye' width='1.25rem' height='1.25rem' />
              </Link>
              <Text weight='semi-bold' color='tertiary'>
                {genericRule.name}
              </Text>
            </Flex>
          )}
        </Card.Body>
      </Card>
    </>
  );
};

export default PinnedGenericRule;
